import { Menu, MenuItem } from "@blueprintjs/core";
import React from "react";

import { AssetDTO, useDeletePlayVideoMutation } from "../../redux/slices";

export interface PlayVideoContextMenuProps {
  video: AssetDTO;
  playId: string;
}

export const PlayVideoContextMenu = ({ video, playId }: PlayVideoContextMenuProps) => {
  const [deletePlayVideo] = useDeletePlayVideoMutation();

  const onDelete = () => {
    deletePlayVideo({ playId, assetId: video.id });
  };

  return (
    <Menu>
      <MenuItem text={`Remove Video From Play`} onClick={onDelete} icon="trash" />
    </Menu>
  );
};
